import styled from "@emotion/styled";
import React from "react";
import { useTranslation } from "react-i18next";

interface ModalContentProps {
  mainMessage: string;
  subMessage?: string;
}

const Content = styled.div(({ theme }) => ({
  lineHeight: "2.4rem",
  padding: "4.4rem 0",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
}));

export const ModalContent: React.FC<ModalContentProps> = ({
  mainMessage,
  subMessage,
}) => {
  const { t } = useTranslation();

  return (
    <Content>
      <p>{t(mainMessage)}</p>
      <p>{t(subMessage ? subMessage : "")}</p>
    </Content>
  );
};
